import React from 'react';
import { css } from '@emotion/react';
import { i18n_hear_from_our_community } from '@yi/i18n/phrases/i18n_hear_from_our_community';
import { i18n_join_community_of_over_1_000_000_people_we_ve_been_empowering_since_1991 } from '@yi/i18n/phrases/i18n_join_community_of_over_1_000_000_people_we_ve_been_empowering_since_1991';

import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints, fontWeight, paddingVariables, typography } from '~/src/styles';
import { resetStyles } from '~/src/styles/reset-styles-mixins';

import { TestimonialCarousel } from './TestimonialCarousel';
import { commonStyles } from '../common-styles';

const styles = {
  container: css(commonStyles.containerMaxWidth, {
    display: 'grid',
    overflowX: 'hidden',
    gridTemplateAreas: `
        '.'
        'title'
        '.'
        'carousel'
        '.'
        'text'
        '.'
    `,
    gridTemplateRows: `var(--Section-Padding) auto var(--SubHeading-Padding) auto var(--Section-Padding) auto var(--Section-Padding)`,
    [breakpoints.minTablet]: {
      gridTemplateColumns: `100%`,
      gridTemplateRows: `${paddingVariables.p80} auto ${paddingVariables.p80} auto ${paddingVariables.p80} auto ${paddingVariables.p80}`,
    },
    [breakpoints.minDesktop]: {
      margin: 'auto',
      gridTemplateRows: `${paddingVariables.p120} auto ${paddingVariables.p120} auto ${paddingVariables.p120} auto ${paddingVariables.p120}`,
    },
  }),

  title: css(commonStyles.contentPadding, typography.heading1, {
    gridArea: 'title',
    color: 'var(--Dark-Text, #27292D)',
    textTransform: 'capitalize',
    [breakpoints.minTablet]: {
      textAlign: `center`,
    },
  }),
  carousel: css(commonStyles.contentPadding, commonStyles.carouselContainerStyles, {
    gridArea: 'carousel',
    [breakpoints.minTablet]: {
      width: '100%',
      padding: '0 34px',
    },
    [breakpoints.minDesktop]: {
      width: '100%',
      padding: '0 32px',
    },
  }),
  text: css(resetStyles.heading, commonStyles.contentPadding, {
    color: 'var(--Dark-Text, #27292D)',
    gridArea: 'text',
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontWeight: fontWeight.semiBold,
    lineHeight: '26px',
    letterSpacing: '0.05em',
    [breakpoints.minTablet]: css({
      textAlign: 'center',
      fontSize: '24px',
      fontWeight: '700',
      lineHeight: '40px',
      letterSpacing: '1.2px',
    }),
    [breakpoints.minDesktop]: css(typography.heading3, {
      textAlign: 'left',
    }),
  }),
};

export const HearFromOurCommunity: React.FC = () => {
  const { locale } = useLocale();

  return (
    <section css={styles.container}>
      <h1 css={styles.title}>{i18n_hear_from_our_community(locale)}</h1>
      <TestimonialCarousel css={styles.carousel} />
      <h2 css={styles.text}>
        {i18n_join_community_of_over_1_000_000_people_we_ve_been_empowering_since_1991(locale)}
      </h2>
    </section>
  );
};
